import { useRef, useState } from 'react'
import Immutable from 'immutable'
import loadable from '@loadable/component'

import { extractGoogleMapsEmbedded } from './extractGoogleMapsSource'
import { useTranslate } from '../../../../../utils/translate'

/* istanbul ignore next */
const SettingsLayer = loadable(() => import(/* webpackChunkName: "editor" */ '../../SettingsLayer'))
/* istanbul ignore next */
const GoogleMapsSettingsForm = loadable(() => import(/* webpackChunkName: "editor" */ './GoogleMapsSettings'))

export default function GoogleMapsPlugin({
  editorView,
  editorMode,
  data = Immutable.fromJS({ iframe: '' }),
  onDataChange,
  onSave,
  onCancel,
  onEdit,
}: Readonly<WorkspacePluginProps>) {
  const [isActive, setIsActive] = useState(false)

  const t = useTranslate('interface')

  const rootElement = useRef(null)

  const renderGoogleMaps = (pb) => {
    return (
      <div className="dali-plugin-maps-container">
        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
        <iframe
          className="dali-plugin-maps-content"
          src={`https://www.google.com/maps/embed?pb=${pb}`}
          loading="lazy"
          allowFullScreen
        />
      </div>
    )
  }

  const isEmpty = !data.get('iframe')
  const googleMapsPb = extractGoogleMapsEmbedded(data.get('iframe'))
  const googleMapsPlaceholder = (
    <div className="dali-grid-element-placeholder">
      <span className="dali-grid-element-placeholder-icon dali-plugin-maps-placeholder-icon" />
      <button className="dali-grid-element-placeholder-button" onClick={onEdit as any}>
        {t('components.gmapsElementComponent.addMapButton.label')}
      </button>
    </div>
  )

  if (editorView) {
    return (
      <div
        className={`dali-plugin-maps ${isActive ? 'dali-grid-element-highlighted' : ''}`}
        data-testid="highlighted-element"
        ref={rootElement}
      >
        {isEmpty ? googleMapsPlaceholder : renderGoogleMaps(googleMapsPb)}
        <SettingsLayer
          open={editorMode === 'edit'}
          onActiveStateChange={setIsActive}
          virtualRef={rootElement}
          side="right"
          onEscapeKeyDown={onCancel}
        >
          {({ renderLayout }) => <GoogleMapsSettingsForm {...{ data, onDataChange, onSave, onCancel, renderLayout }} />}
        </SettingsLayer>
      </div>
    )
  }
  return !googleMapsPb ? null : <div className="dali-plugin-maps">{renderGoogleMaps(googleMapsPb)}</div>
}
